import type { MissionPlayerTheme } from '../theme'

import { styled, type StyledComponent } from 'styled-components'

export const CssVariableThemeDefinitions: StyledComponent<
	{||},
	MissionPlayerTheme,
	HTMLDivElement
> = styled.div`
	display: contents;
	--z-index-always-show: 4;
	${({ theme }: { theme: MissionPlayerTheme }) => `
	// Spacing
		--spacing: ${theme.spacing};
		--spacing-half: ${theme.spacingHalf};
		--spacing-2x: ${theme.spacing2x};
		--spacing-3x: ${theme.spacing3x};
		--spacing-4x: ${theme.spacing4x};
    // Font Sizes	
		--fontsize-xxxs: ${theme.fontxxxs};	
		--fontsize-s: ${theme.fonts};
		--fontsize-l: ${theme.fontl};
		--fontsize-m: ${theme.fontm};
		--fontsize-xl: ${theme.fontxl};
    `}
`
